module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable31.7c38af66.jpg";